import { CategoryModalView } from '@/javascripts/category_modal_mobile';
import Mute from '@/javascripts/components/Mute';

document.addEventListener('DOMContentLoaded', () => {
  const categorySearch = document.querySelector('#question-category-search');
  const statusSearch = document.querySelector('#question-status-search');

  if (categorySearch) new CategoryModalView(categorySearch as HTMLElement);
  if (statusSearch) new CategoryModalView(statusSearch as HTMLElement);

  new Mute().addToggleMuteEvent();
});
